var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99727 10.6875C3.03047 10.6875 2.25 9.93516 2.25 9C2.25 8.06836 3.03047 7.3125 3.99727 7.3125C4.96758 7.3125 5.74805 8.06836 5.74805 9C5.74805 9.93516 4.96758 10.6875 3.99727 10.6875Z",
    fill: "#939393"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00005 10.6875C8.03325 10.6875 7.24927 9.93516 7.24927 9C7.24927 8.06836 8.03325 7.3125 9.00005 7.3125C9.96685 7.3125 10.7473 8.06836 10.7473 9C10.7473 9.93516 9.96685 10.6875 9.00005 10.6875Z",
    fill: "#939393"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9993 10.6875C13.0325 10.6875 12.2485 9.93516 12.2485 9C12.2485 8.06836 13.029 7.3125 13.9993 7.3125C14.9661 7.3125 15.7501 8.06836 15.7501 9C15.7501 9.93516 14.9696 10.6875 13.9993 10.6875Z",
    fill: "#939393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.a2ec6bee8b7a531e0f8092eb3f9266e3.svg";
export { ForwardRef as ReactComponent };